import Api from './ApiAxios';

export { setupInterceptors } from './ApiAxios';
export default Api;
